import React from 'react'

import { IContest } from 'protos'
import { MessageKey } from 'types'

import T from 'components/FormattedMessage'
import Countdown from 'components/Countdown'

import Label from './Label'

interface Props {
  time: IContest['startTime'] | IContest['endTime']
  labelKey: MessageKey,
}

const calculateRemaining = (time: IContest['startTime'] | IContest['endTime']): number => {
  return time ? +time - Math.round(Date.now() / 1000) : 0
}

const CountdownLabel: React.SFC<Props> = ({ time, labelKey }) => (
  <Label
    label={<T id={labelKey} />}
    value={<Countdown remainingSec={calculateRemaining(time)} />}
  />
)

export default CountdownLabel
